export default __webpack_public_path__ + "static/media/bg-black.46f91115.png";